import React, { useEffect, useState } from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import Phone from 'components/Phone';
import ReferralLayout from 'components/ReferralLayout';
import DownloadAppButton from 'components/DownloadAppButton';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { sendSms } from 'api/Notifications';
import { logInvitedUserDownloadPageViewed } from '@alltrails/analytics/amplitudeFunctions';
import * as styles from './styles.module.scss';
import downloadSrc from './download.svg';
import landingPage2Avif from './landing-page-2-1400w.avif';
import landingPage2Webp from './landing-page-2-1400w.webp';
import landingPage2Jpg from './landing-page-2-1400w.jpg';

const { JUST_ONE_MORE_STEP, PHONE_DOWNLOAD_ICON, SEND_A_LINK_TO_MY_PHONE, SEND_LINK, SENT, THANKS_FOR_PROVIDING_YOUR_EMAIL, TWO_PEOPLE_FACING } =
  StringConstantsMixin.strings;

function ReferralDownload() {
  const languageRegionCode = useLanguageRegionCode();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isWorking, setIsWorking] = useState(false);
  const [success, setSuccess] = useState();
  const [error, setError] = useState();

  function handleChange(isValid, newNumber, countryData, fullNumber) {
    setPhoneNumber(fullNumber);
  }

  async function sendTextMessage() {
    try {
      setIsWorking(true);

      await sendSms(languageRegionCode, phoneNumber);

      setSuccess(true);
    } catch (e) {
      setError(true);
    } finally {
      setIsWorking(false);
    }
  }

  useEffect(() => {
    logInvitedUserDownloadPageViewed();
  }, []);

  return (
    <>
      <ReferralLayout
        activeStep={1}
        heroAvif={landingPage2Avif}
        heroWebp={landingPage2Webp}
        heroJpg={landingPage2Jpg}
        heroAlt={TWO_PEOPLE_FACING}
        heading={JUST_ONE_MORE_STEP}
        iconSrc={downloadSrc}
        iconAlt={PHONE_DOWNLOAD_ICON}
        paragraphText={THANKS_FOR_PROVIDING_YOUR_EMAIL}
      >
        <div className={styles.link}>
          <p className={styles.sendALink}>{SEND_A_LINK_TO_MY_PHONE}</p>
          <Phone classes={styles.phone} error={error} onChange={handleChange} />
          <Button
            text={success ? SENT : SEND_LINK}
            disabled={isWorking}
            loading={isWorking}
            onClick={sendTextMessage}
            testId="referral-download-send-link"
            variant="primary"
          />
        </div>
        {/* wrapper required because of the coded display: flex in monorepo */}
        <div className={styles.download}>
          <DownloadAppButton />
        </div>
      </ReferralLayout>
    </>
  );
}

export default ReferralDownload;
